import React, { useEffect, useState } from "react";
import { useStoreRoom, useStoreSystem } from "../../../store";
import { DecorItemI } from "../../../shared";
import EditPencil from "../../icons/EditPencil";
import * as THREE from "three";
import Remove from "../../icons/Remove/Remove";
import shallow from "zustand/shallow";
import { useCurrent } from "../../../hooks/useCurrent";

interface DecorLabelProps {
    camera: any;
    canvasSize: any;
}

interface DecorLabelBtnProps {
    position: {
        left: number;
        top: number;
    };
    onEdit(): void;
    onRemove(): void;
}

function useDecorPosition(canvasSize: any, camera: any) {
    return (decor: DecorItemI) => {
        const position = new THREE.Vector3(...decor.position);

        position.project(camera);

        const left = ((position.x + 1) * canvasSize?.width) / 2;
        const top = (-(position.y - 1) * canvasSize?.height) / 2;

        return {
            left,
            top,
        };
    };
}

const DecorLabelBtn: React.FC<DecorLabelBtnProps> = (props) => {
    const { position, onEdit, onRemove } = props;

    return (
        <>
            <EditPencil
                onClick={onEdit}
                isChecked
                style={{
                    transform: `translate(${position.left - 40}px, ${position.top}px)`,
                }}
            />
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    borderRadius: 50,
                    alignItems: "center",
                    justifyContent: "space-between",
                    display: "flex",
                    backgroundColor: "#FFFFFF",
                    height: "29px",
                    padding: "1px",
                    border: "2px solid #ffffff",
                    boxShadow: "0px 4px 4px rgba(17, 17, 17, 0.36)",
                    transform: `translate(${position.left}px, ${position.top + 5}px)`,
                }}
            >
                <Remove onClick={onRemove} variant="primary" />
            </div>
        </>
    );
};

export const DecorsLabels: React.FC<DecorLabelProps> = ({ canvasSize, camera }) => {
    const { decors, removeDecor } = useStoreRoom(
        (state) => ({
            decors: state.decors,
            removeDecor: state.removeDecor,
        }),
        shallow
    );
    const { selectDecor } = useStoreSystem((state) => ({
        selectDecor: state.selectDecor,
    }));
    const { currentEditItem } = useCurrent();
    const calcPosition = useDecorPosition(canvasSize, camera);
    const [currentDecor, setCurrentDecor] = useState<DecorItemI | undefined>();

    //FIXME при зуме камеры происходит обовление labels, за счет этого происходит рендер этого компонента, соответственно пересчитывается положение кнопок. Выглядит как костыль. Сами значения labels нигде не используются
    useStoreSystem((state) => state.labels, shallow); //TODO надо решить надо ли оно тут

    const handleEditDecor = (decor: DecorItemI) => () => {
        selectDecor(decor.id);
    };

    const handleRemoveDecor = (decor: DecorItemI) => () => {
        removeDecor(decor.id);
    };

    useEffect(() => {
        setCurrentDecor(decors.find((decor) => decor.id === currentEditItem.id));
    }, [currentEditItem, decors]);

    return (
        <>
            {currentDecor && (
                <DecorLabelBtn
                    key={currentDecor.id}
                    position={calcPosition(currentDecor)}
                    onEdit={handleEditDecor(currentDecor)}
                    onRemove={handleRemoveDecor(currentDecor)}
                />
            )}
        </>
    );
};
